import React, { Suspense } from 'react';
import BaseGrid from 'components/atoms/base-grid';
import { AgentsActivity } from 'roger-call-dashboard';
import CallDashboardMetricsPageHeader from 'components/organisms/call-agents-dashboard/page-header';
import BaseLoader from 'components/atoms/base-loader';
import { Routes } from 'router/routes';

import s from './styles.module.scss';

const CallAgentsDashboardActivityPage: React.FC = () => {
  return (
    <BaseGrid className={s.wrapper} rowGap={40}>
      <CallDashboardMetricsPageHeader />
      <Suspense fallback={<BaseLoader loading relative />}>
        <AgentsActivity
          agentProfilePath={({ userId }) => Routes.callAgentProfile(userId)}
        />
      </Suspense>
    </BaseGrid>
  );
};

export default CallAgentsDashboardActivityPage;
